module.exports = __webpack_public_path__ + "static/img/defender4.fe0534b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/defender4.png
// module id = fzRW
// module chunks = 0